module.exports = __webpack_public_path__ + "img/ai_main1.5bf4f8d2.png";